"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownTimeBannerService = void 0;
const config_1 = require("../config/config");
const api_1 = require("./api");
const PATH = '/loyalty/management/health';
const PATH_v2 = '/activity/management/health';
class DownTimeBannerService {
    static async getLoyaltyServiceStatus() {
        try {
            return await api_1.API.get({
                url: `${config_1.react_core_config.internalConfig.gatewayV2 ? PATH_v2 : PATH}`
            });
        }
        catch (e) {
            return {
                error: e
            };
        }
    }
}
exports.DownTimeBannerService = DownTimeBannerService;
//# sourceMappingURL=downtime-banner-service.js.map